import InstitutLicencePage from '@/pages/institut/licence/page';
import InstitutMasterPage from '@/pages/institut/master/page';
import InstitutOrientationPage from '@/pages/institut/orienation/page';
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Pages d'authentification
const ConnexionPage = lazy(() => import('../pages/auth/connexion/page'));
const InscriptionPage = lazy(() => import('../pages/auth/inscription/page'));
const MotDePasseOubliePage = lazy(() => import('../pages/auth/mot-de-passe-oublie/page'));
const AdminConnexionPage = lazy(() => import('../pages/auth/admin-connexion/page'));

// Pages globales
const AProposPage = lazy(() => import('../pages/a-propos/page'));

// Établissements
const InstancesPage = lazy(() => import('../pages/etablissements/instances/page'));
const MotProviseurPage = lazy(() => import('../pages/etablissements/mot-proviseur/page'));
const EquipePage = lazy(() => import('../pages/etablissements/equipe/page'));
const ProviseurPage = lazy(() => import('../pages/etablissements/proviseur/page'));

// Structures
const RestaurantPage = lazy(() => import('../pages/structures/restaurant/page'));
const TransportPage = lazy(() => import('../pages/structures/transport/page'));
const CDIPage = lazy(() => import('../pages/structures/cdi/page'));

// Inscription
const FraisPage = lazy(() => import('../pages/inscription/frais/page'));
const FourniturePage = lazy(() => import('../pages/inscription/fourniture/page'));

// Infos pratiques
const CalendrierPage = lazy(() => import('../pages/infos-pratiques/calendrier/page'));
const AssociationSportivePage = lazy(() => import('../pages/infos-pratiques/association-sportive/page'));
const ActiviteExtraPage = lazy(() => import('../pages/infos-pratiques/activite-extra/page'));

// Parcours élèves
const CollegePage = lazy(() => import('../pages/parcours/college/page'));
const LyceePage = lazy(() => import('../pages/parcours/lycee/page'));
const OrientationPage = lazy(() => import('../pages/parcours/orientation/page'));

// Actualités
const EvenementsPage = lazy(() => import('../pages/actualites/evenements/page'));
const ProjetsPage = lazy(() => import('../pages/actualites/projets/page'));
const GaleriePage = lazy(() => import('../pages/actualites/galerie/page'));

// Outils
const EsidocPage = lazy(() => import('../pages/outils/esidoc/page'));
const PronotePage = lazy(() => import('../pages/outils/pronote/page'));

// Contact
const ContactPage = lazy(() => import('../pages/contact/page'));

// Établissements
const InstitutPage = lazy(() => import('../pages/institut/page'));
const LyceeFrancaisPage = lazy(() => import('../pages/lycee-francais/page'));
const LyceeIvoirienPage = lazy(() => import('../pages/lycee-ivoirien/page'));
const MaternellePrimairePage = lazy(() => import('../pages/maternelle-primaire/page'));

// Pages de détails
const EvenementDetailPage = lazy(() => import('../pages/evenements/detail/page'));
const ProjetDetailPage = lazy(() => import('../pages/projets/detail/page'));

// Admin pages
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminEvenementsPage = lazy(() => import('../pages/admin/evenements/page'));
const AdminProjetsPage = lazy(() => import('../pages/admin/projets/page'));
const AdminGaleriesPage = lazy(() => import('../pages/admin/galeries/page'));
const AdminMessagesPage = lazy(() => import('../pages/admin/messages/page'));
const AdminEcolesPage = lazy(() => import('../pages/admin/ecoles/page'));
const AdminAdministrateursPage = lazy(() => import('../pages/admin/administrateurs/page'));

// Institut pages
const InstitutInstancesPage = lazy(() => import('../pages/institut/instances/page'));
const InstitutMotDirecteurPage = lazy(() => import('../pages/institut/mot-directeur/page'));
const InstitutEquipePage = lazy(() => import('../pages/institut/equipe/page'));
const InstitutRestaurantPage = lazy(() => import('../pages/institut/restaurant/page'));
const InstitutTransportPage = lazy(() => import('../pages/institut/transport/page'));
const InstitutCDIPage = lazy(() => import('../pages/institut/cdi/page'));
const InstitutFraisPage = lazy(() => import('../pages/institut/frais/page'));
const InstitutFourniturePage = lazy(() => import('../pages/institut/fourniture/page'));
const InstitutCalendrierPage = lazy(() => import('../pages/institut/calendrier/page'));
const InstitutAssociationSportivePage = lazy(() => import('../pages/institut/association-sportive/page'));
const InstitutActiviteExtraPage = lazy(() => import('../pages/institut/activite-extra/page'));
const InstitutEntrepreneuriatPage = lazy(() => import('../pages/institut/entrepreneuriat/page'));
const InstitutActualitesPage = lazy(() => import('../pages/institut/actualites/page'));
const InstitutEvenementsPage = lazy(() => import('../pages/institut/evenements/page'));
const InstitutProjetsPage = lazy(() => import('../pages/institut/projets/page'));
const InstitutGaleriePage = lazy(() => import('../pages/institut/galerie/page'));
const InstitutContactPage = lazy(() => import('../pages/institut/contact/page'));
const InstitutEsidocPage = lazy(() => import('../pages/institut/esidoc/page'));
const InstitutPronotePage = lazy(() => import('../pages/institut/pronote/page'));

// Lycée Français pages
const LyceeFrancaisInstancesPage = lazy(() => import('../pages/lycee-francais/instances/page'));
const LyceeFrancaisMotProviseurPage = lazy(() => import('../pages/lycee-francais/mot-proviseur/page'));
const LyceeFrancaisEquipePage = lazy(() => import('../pages/lycee-francais/equipe/page'));
const LyceeFrancaisRestaurantPage = lazy(() => import('../pages/lycee-francais/restaurant/page'));
const LyceeFrancaisTransportPage = lazy(() => import('../pages/lycee-francais/transport/page'));
const LyceeFrancaisVieScolairePage = lazy(() => import('../pages/lycee-francais/vie-scolaire/page'));
const LyceeFrancaisCDIPage = lazy(() => import('../pages/lycee-francais/cdi/page'));
const LyceeFrancaisFraisPage = lazy(() => import('../pages/lycee-francais/frais/page'));
const LyceeFrancaisReglementPage = lazy(() => import('../pages/lycee-francais/reglement/page'));
const  LyceeFrancaisEnquetePage =   lazy(() => import('../pages/lycee-francais/enquete/page'));
const LyceeFrancaisFourniturePage = lazy(() => import('../pages/lycee-francais/fourniture/page'));
const LyceeFrancaisCalendrierPage = lazy(() => import('../pages/lycee-francais/calendrier/page'));
const LyceeFrancaisAssociationSportivePage = lazy(() => import('../pages/lycee-francais/association-sportive/page'));
const LyceeFrancaisActiviteExtraPage = lazy(() => import('../pages/lycee-francais/activite-extra/page'));
const LyceeFrancaisActualitesPage = lazy(() => import('../pages/lycee-francais/actualites/page'));
const LyceeFrancaisEvenementsPage = lazy(() => import('../pages/lycee-francais/evenements/page'));
const LyceeFrancaisProjetsPage = lazy(() => import('../pages/lycee-francais/projets/page'));
const LyceeFrancaisGaleriePage = lazy(() => import('../pages/lycee-francais/galerie/page'));
const LyceeFrancaisPronotePage = lazy(() => import('../pages/lycee-francais/pronote/page'));
const LyceeFrancaisContactPage = lazy(() => import('../pages/lycee-francais/contact/page'));
const LyceeFrancaisCollegePage = lazy(() => import('../pages/lycee-francais/college/page'));
const LyceeFrancaisLyceePage = lazy(() => import('../pages/lycee-francais/lycee/page'));
const LyceeFrancaisOrientationPage = lazy(() => import('../pages/lycee-francais/orientation/page'));
const LyceeFrancaisEsidocPage = lazy(() => import('../pages/lycee-francais/esidoc/page'));
const LyceeFrancaisPolitiqueLinguistiquePage = lazy(() => import('../pages/lycee-francais/politique-linguistique/page'));

// Lycée Ivoirien pages
const LyceeIvoirienInstancesPage = lazy(() => import('../pages/lycee-ivoirien/instances/page'));
const LyceeIvoirienMotProviseurPage = lazy(() => import('../pages/lycee-ivoirien/mot-proviseur/page'));
const LyceeIvoirienEquipePage = lazy(() => import('../pages/lycee-ivoirien/equipe/page'));
const LyceeIvoirienRestaurantPage = lazy(() => import('../pages/lycee-ivoirien/restaurant/page'));
const LyceeIvoirienTransportPage = lazy(() => import('../pages/lycee-ivoirien/transport/page'));
const LyceeIvoirienCDIPage = lazy(() => import('../pages/lycee-ivoirien/cdi/page'));
const LyceeIvoirienFraisPage = lazy(() => import('../pages/lycee-ivoirien/frais/page'));
const LyceeIvoirienFourniturePage = lazy(() => import('../pages/lycee-ivoirien/fourniture/page'));
const LyceeIvoirienCalendrierPage = lazy(() => import('../pages/lycee-ivoirien/calendrier/page'));
const LyceeIvoirienAssociationSportivePage = lazy(() => import('../pages/lycee-ivoirien/association-sportive/page'));
const LyceeIvoirienActiviteExtraPage = lazy(() => import('../pages/lycee-ivoirien/activite-extra/page'));
const LyceeIvoirienActualitesPage = lazy(() => import('../pages/lycee-ivoirien/actualites/page'));
const LyceeIvoirienEvenementsPage = lazy(() => import('../pages/lycee-ivoirien/evenements/page'));
const LyceeIvoirienProjetsPage = lazy(() => import('../pages/lycee-ivoirien/projets/page'));
const LyceeIvoirienGaleriePage = lazy(() => import('../pages/lycee-ivoirien/galerie/page'));
const LyceeIvoirienCollegePage = lazy(() => import('../pages/lycee-ivoirien/college/page'));
const LyceeIvoirienLyceePage = lazy(() => import('../pages/lycee-ivoirien/lycee/page'));
const LyceeIvoirienOrientationPage = lazy(() => import('../pages/lycee-ivoirien/orientation/page'));
const LyceeIvoirienContactPage = lazy(() => import('../pages/lycee-ivoirien/contact/page'));
const LyceeIvoirienEsidocPage = lazy(() => import('../pages/lycee-ivoirien/esidoc/page'));
const LyceeIvoirienPronotePage = lazy(() => import('../pages/lycee-ivoirien/pronote/page'));
const LyceeIvoirienReglementPage = lazy(() => import('../pages/lycee-ivoirien/reglement/page'));

// Maternelle & Primaire pages
const MaternellePrimaireInstancesPage = lazy(() => import('../pages/maternelle-primaire/instances/page'));
const MaternellePrimaireMotDirecteurPage = lazy(() => import('../pages/maternelle-primaire/mot-directeur/page'));
const MaternellePrimaireFraisPage = lazy(() => import('../pages/maternelle-primaire/frais/page'));
const MaternellePrimaireFourniturePage = lazy(() => import('../pages/maternelle-primaire/fourniture/page'));
const MaternellePrimaireAssociationSportivePage = lazy(() => import('../pages/maternelle-primaire/association-sportive/page'));
const MaternellePrimaireActiviteExtraPage = lazy(() => import('../pages/maternelle-primaire/activite-extra/page'));
const MaternellePrimaireEquipePage = lazy(() => import('../pages/maternelle-primaire/equipe/page'));
const MaternellePrimaireRestaurantPage = lazy(() => import('../pages/maternelle-primaire/restaurant/page'));
const MaternellePrimaireTransportPage = lazy(() => import('../pages/maternelle-primaire/transport/page'));
const MaternellePrimaireCDIPage = lazy(() => import('../pages/maternelle-primaire/cdi/page'));
const MaternellePrimaireCalendrierPage = lazy(() => import('../pages/maternelle-primaire/calendrier/page'));
const MaternellePrimaireEvenementsPage = lazy(() => import('../pages/maternelle-primaire/evenements/page'));
const MaternellePrimaireProjetsPage = lazy(() => import('../pages/maternelle-primaire/projets/page'));
const MaternellePrimaireGaleriePage = lazy(() => import('../pages/maternelle-primaire/galerie/page'));
const MaternellePrimaireContactPage = lazy(() => import('../pages/maternelle-primaire/contact/page'));
const MaternellePrimaireEsidocPage = lazy(() => import('../pages/maternelle-primaire/esidoc/page'));
const MaternellePrimairePronotePage = lazy(() => import('../pages/maternelle-primaire/pronote/page'));

const routes: RouteObject[] = [
  // {
  
  //   path: '/',
  //   element: <HomePage />,
  // },
  {
    path: '/',
    element: <InstitutPage />,
  },
  // Pages d'authentification
  {
    path: '/auth/connexion',
    element: <ConnexionPage />,
  },
  {
    path: '/auth/inscription',
    element: <InscriptionPage />,
  },
  {
    path: '/auth/mot-de-passe-oublie',
    element: <MotDePasseOubliePage />,
  },
  {
    path: '/auth/admin-connexion',
    element: <AdminConnexionPage />,
  },
  // Admin routes
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/evenements',
    element: <AdminEvenementsPage />,
  },
  {
    path: '/admin/projets',
    element: <AdminProjetsPage />,
  },
  {
    path: '/admin/galeries',
    element: <AdminGaleriesPage />,
  },
  {
    path: '/admin/messages',
    element: <AdminMessagesPage />,
  },
  {
    path: '/admin/administrateurs',
    element: <AdminAdministrateursPage />,
  },
  {
    path: '/admin/ecoles',
    element: <AdminEcolesPage />,
  },
  // Pages globales
  {
    path: '/a-propos',
    element: <AProposPage />,
  },
  // Établissements
  {
    path: '/etablissements/instances',
    element: <InstancesPage />,
  },
  {
    path: '/etablissements/mot-proviseur',
    element: <MotProviseurPage />,
  },
  {
    path: '/etablissements/equipe',
    element: <EquipePage />,
  },
  {
    path: '/etablissements/proviseur',
    element: <ProviseurPage />,
  },
  // Structures
  {
    path: '/structures/restaurant',
    element: <RestaurantPage />,
  },
  {
    path: '/structures/transport',
    element: <TransportPage />,
  },
  {
    path: '/structures/cdi',
    element: <CDIPage />,
  },
  // Inscription
  {
    path: '/inscription/frais',
    element: <FraisPage />,
  },
  {
    path: '/inscription/fourniture',
    element: <FourniturePage />,
  },
  // Infos pratiques
  {
    path: '/infos-pratiques/calendrier',
    element: <CalendrierPage />,
  },
  {
    path: '/infos-pratiques/association-sportive',
    element: <AssociationSportivePage />,
  },
  {
    path: '/infos-pratiques/activite-extra',
    element: <ActiviteExtraPage />,
  },
  // Parcours élèves
  {
    path: '/parcours/college',
    element: <CollegePage />,
  },
  {
    path: '/parcours/lycee',
    element: <LyceePage />,
  },
  {
    path: '/parcours/orientation',
    element: <OrientationPage />,
  },
  // Actualités
  {
    path: '/actualites/evenements',
    element: <EvenementsPage />,
  },
  {
    path: '/actualites/projets',
    element: <ProjetsPage />,
  },
  {
    path: '/actualites/galerie',
    element: <GaleriePage />,
  },
  // Outils
  {
    path: '/outils/esidoc',
    element: <EsidocPage />,
  },
  {
    path: '/outils/pronote',
    element: <PronotePage />,
  },
  // Contact
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/institut',
    element: <InstitutPage />,
  },
  {
    path: '/lycee-francais',
    element: <LyceeFrancaisPage />,
  },
  {
    path: '/lycee-francais/politique-linguistique',
    element: <LyceeFrancaisPolitiqueLinguistiquePage />,
  },
  {
    path: '/lycee-ivoirien',
    element: <LyceeIvoirienPage />,
  },
  {
    path: '/maternelle-primaire',
    element: <MaternellePrimairePage />,
  },
  // {
  //   path: '/maternelle-primaire/frais',
  //   element: lazy(() => import('../pages/maternelle-primaire/frais/page')),
  // },
  // {
  //   path: '/maternelle-primaire/fourniture',
  //   element: lazy(() => import('../pages/maternelle-primaire/fourniture/page')),
  // },
  // {
  //   path: '/maternelle-primaire/activite-extra',
  //   element: lazy(() => import('../pages/maternelle-primaire/activite-extra/page')),
  // },
  // {
  //   path: '/maternelle-primaire/association-sportive',
  //   element: lazy(() => import('../pages/maternelle-primaire/association-sportive/page')),
  // },
  {
    path: '/maternelle-primaire/instances',
    element: <MaternellePrimaireInstancesPage />,
  },
  {
    path: '/maternelle-primaire/mot-directeur',
    element: <MaternellePrimaireMotDirecteurPage />,
  },


  {
    path: '/maternelle-primaire/frais',
    element: <MaternellePrimaireFraisPage />,
  },
  {
    path: '/maternelle-primaire/fourniture',
    element: <MaternellePrimaireFourniturePage />,
  },
  {
    path: '/maternelle-primaire/association-sportive',
    element: <MaternellePrimaireAssociationSportivePage />,
  },
  {
    path: '/maternelle-primaire/activite-extra',
    element: <MaternellePrimaireActiviteExtraPage />,
  },
  {
    path: '/maternelle-primaire/equipe',
    element: <MaternellePrimaireEquipePage />,
  },
  {
    path: '/maternelle-primaire/restaurant',
    element: <MaternellePrimaireRestaurantPage />,
  },
  {
    path: '/maternelle-primaire/transport',
    element: <MaternellePrimaireTransportPage />,
  },
  {
    path: '/maternelle-primaire/cdi',
    element: <MaternellePrimaireCDIPage />,
  },
  {
    path: '/maternelle-primaire/calendrier',
    element: <MaternellePrimaireCalendrierPage />,
  },
  {
    path: '/maternelle-primaire/evenements',
    element: <MaternellePrimaireEvenementsPage />,
  },
  {
    path: '/maternelle-primaire/projets',
    element: <MaternellePrimaireProjetsPage />,
  },
  {
    path: '/maternelle-primaire/galerie',
    element: <MaternellePrimaireGaleriePage />,
  },
  {
    path: '/maternelle-primaire/contact',
    element: <MaternellePrimaireContactPage />,
  },
  {
    path: '/maternelle-primaire/esidoc',
    element: <MaternellePrimaireEsidocPage />,
  },
  {
    path: '/maternelle-primaire/pronote',
    element: <MaternellePrimairePronotePage />,
  },
  // Pages de détails
  {
    path: '/evenements/detail',
    element: <EvenementDetailPage />,
  },
  {
    path: '/projets/detail',
    element: <ProjetDetailPage />,
  },
  // Institut routes
  {
    path: '/institut/instances',
    element: <InstitutInstancesPage />,
  },
  {
    path: '/institut/mot-directeur',
    element: <InstitutMotDirecteurPage />,
  },
  {
    path: '/institut/equipe',
    element: <InstitutEquipePage />,
  },
  {
    path: '/institut/restaurant',
    element: <InstitutRestaurantPage />,
  },
  {
    path: '/institut/transport',
    element: <InstitutTransportPage />,
  },
  {
    path: '/institut/cdi',
    element: <InstitutCDIPage />,
  },
  {
    path: '/institut/frais',
    element: <InstitutFraisPage />,
  },
  {
    path: '/institut/fourniture',
    element: <InstitutFourniturePage />,
  },
  {
    path: '/institut/calendrier',
    element: <InstitutCalendrierPage />,
  },
  {
    path: '/institut/association-sportive',
    element: <InstitutAssociationSportivePage />,
  },
  {
    path: '/institut/activites-extra-universitaires',
    element: <InstitutActiviteExtraPage />,
  },
  {
    path: '/institut/entrepreneuriat',
    element: <InstitutEntrepreneuriatPage />,
  },
  {
    path: '/institut/licence',
    element: <InstitutLicencePage />,
  },
  {
    path: '/institut/master',
    element: <InstitutMasterPage />,
  },
  {
    path: '/institut/orientation',
    element: <InstitutOrientationPage />,
  },
  {
    path: '/institut/actualites',
    element: <InstitutActualitesPage />,
  },
  {
    path: '/institut/evenements',
    element: <InstitutEvenementsPage />,
  },
  {
    path: '/institut/projets',
    element: <InstitutProjetsPage />,
  },
  {
    path: '/institut/galerie',
    element: <InstitutGaleriePage />,
  },
  {
    path: '/institut/contact',
    element: <InstitutContactPage />,
  },
  {
    path: '/institut/esidoc',
    element: <InstitutEsidocPage />,
  },
  {
    path: '/institut/pronote',
    element: <InstitutPronotePage />,
  },
  // Lycée Français routes
  {
    path: '/lycee-francais/instances',
    element: <LyceeFrancaisInstancesPage />,
  },
  {
    path: '/lycee-francais/mot-proviseur',
    element: <LyceeFrancaisMotProviseurPage />,
  },
  {
    path: '/lycee-francais/equipe',
    element: <LyceeFrancaisEquipePage />,
  },
  {
    path: '/lycee-francais/restaurant',
    element: <LyceeFrancaisRestaurantPage />,
  },
  {
    path: '/lycee-francais/transport',
    element: <LyceeFrancaisTransportPage />,
  },
  {
    path:'/lycee-francais/vie-scolaire',
    element:<LyceeFrancaisVieScolairePage/>
  },
  {
    path: '/lycee-francais/cdi',
    element: <LyceeFrancaisCDIPage />,
  },
  {
    path: '/lycee-francais/frais',
    element: <LyceeFrancaisFraisPage />,
  },
  {
    path:'/lycee-francais/reglement',
    element:<LyceeFrancaisReglementPage/>
  },
  {
    path:'/lycee-francais/enquete',
    element:<LyceeFrancaisEnquetePage/>
  },
  {
    path: '/lycee-francais/fourniture',
    element: <LyceeFrancaisFourniturePage />,
  },
  {
    path: '/lycee-francais/calendrier',
    element: <LyceeFrancaisCalendrierPage />,
  },
  {
    path: '/lycee-francais/association-sportive',
    element: <LyceeFrancaisAssociationSportivePage />,
  },
  {
    path: '/lycee-francais/activite-extra',
    element: <LyceeFrancaisActiviteExtraPage />,
  },
  {
    path: '/lycee-francais/actualites',
    element: <LyceeFrancaisActualitesPage />,
  },
  {
    path: '/lycee-francais/evenements',
    element: <LyceeFrancaisEvenementsPage />,
  },
  {
    path: '/lycee-francais/projets',
    element: <LyceeFrancaisProjetsPage />,
  },
  {
    path: '/lycee-francais/galerie',
    element: <LyceeFrancaisGaleriePage />,
  },
  {
    path: '/lycee-francais/pronote',
    element: <LyceeFrancaisPronotePage />,
  },
  {
    path: '/lycee-francais/contact',
    element: <LyceeFrancaisContactPage />,
  },
  {
    path: '/lycee-francais/college',
    element: <LyceeFrancaisCollegePage />,
  },
  {
    path: '/lycee-francais/lycee',
    element: <LyceeFrancaisLyceePage />,
  },
  {
    path: '/lycee-francais/orientation',
    element: <LyceeFrancaisOrientationPage />,
  },
  {
    path: '/lycee-francais/esidoc',
    element: <LyceeFrancaisEsidocPage />,
  },
  // Lycée Ivoirien routes
  {
    path: '/lycee-ivoirien/instances',
    element: <LyceeIvoirienInstancesPage />,
  },
  {
    path: '/lycee-ivoirien/mot-proviseur',
    element: <LyceeIvoirienMotProviseurPage />,
  },
  {
    path: '/lycee-ivoirien/equipe',
    element: <LyceeIvoirienEquipePage />,
  },
  {
    path: '/lycee-ivoirien/restaurant',
    element: <LyceeIvoirienRestaurantPage />,
  },
  {
    path: '/lycee-ivoirien/transport',
    element: <LyceeIvoirienTransportPage />,
  },
  {
    path: '/lycee-ivoirien/cdi',
    element: <LyceeIvoirienCDIPage />,
  },
  {
    path: '/lycee-ivoirien/frais',
    element: <LyceeIvoirienFraisPage />,
  },
  {
    path: '/lycee-ivoirien/reglement',
    element: <LyceeIvoirienReglementPage />,
  },
  {
    path: '/lycee-ivoirien/fourniture',
    element: <LyceeIvoirienFourniturePage />,
  },
  {
    path: '/lycee-ivoirien/calendrier',
    element: <LyceeIvoirienCalendrierPage />,
  },
  {
    path: '/lycee-ivoirien/association-sportive',
    element: <LyceeIvoirienAssociationSportivePage />,
  },
  {
    path: '/lycee-ivoirien/activite-extra',
    element: <LyceeIvoirienActiviteExtraPage />,
  },
  {
    path: '/lycee-ivoirien/actualites',
    element: <LyceeIvoirienActualitesPage />,
  },
  {
    path: '/lycee-ivoirien/evenements',
    element: <LyceeIvoirienEvenementsPage />,
  },
  {
    path: '/lycee-ivoirien/projets',
    element: <LyceeIvoirienProjetsPage />,
  },
  {
    path: '/lycee-ivoirien/galerie',
    element: <LyceeIvoirienGaleriePage />,
  },
  {
    path: '/lycee-ivoirien/college',
    element: <LyceeIvoirienCollegePage />,
  },
  {
    path: '/lycee-ivoirien/lycee',
    element: <LyceeIvoirienLyceePage />,
  },
  {
    path: '/lycee-ivoirien/orientation',
    element: <LyceeIvoirienOrientationPage />,
  },
  {
    path: '/lycee-ivoirien/contact',
    element: <LyceeIvoirienContactPage />,
  },
  {
    path: '/lycee-ivoirien/esidoc',
    element: <LyceeIvoirienEsidocPage />,
  },
  {
    path: '/lycee-ivoirien/pronote',
    element: <LyceeIvoirienPronotePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
